import React from "react";
import "./styles.css";
import Header from "../header";
import MainContent from "../mainContent";

const HomePage = () => {
  return (
    <div className="home-page-container">
      <Header />
      <MainContent />
    </div>
  );
};

export default HomePage;
